<template>
  <div class="editor-group-toggle">
    <CollapseToggle :target="target" :collapsed="collapsed" />
    <h3 class="text-center">{{ label }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    target: { type: String, required: true },
    collapsed: { type: Boolean, default: true }
  }
};
</script>